import map from 'lodash/map';
import reduce from 'lodash/reduce';

// Compute the total cost of the purchase
export const getProductTotal = (products) => {
  return reduce(
    map(products, (product) => {
      return (
        ((product.payDeposit !== null && product.payDeposit
          ? product.depositProduct.price
          : product.price) +
          product.postagePrice) *
        product.quantity
      );
    }),
    (runningTotal, amount) => {
      return runningTotal + amount;
    },
    0,
  );
};

export const formatDateForApi = (date) => {
  if (!date) return '';
  const dateArray = date.split('/');

  return `${dateArray[0]}-${dateArray[1]}-20${dateArray[2]}`;
};
